/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, string, object, func, array, bool } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import p from 'polyglot/polyglot';

import { createUrl } from 'utils/urlHelper';

import { makeCreateJobOfferForm } from 'selectors/createJobOfferForm';

import {
  DISCUSSION_ACTION_SUCCESS,
  DISCUSSION_ACTION_FAILURE,
  getMessage as getMessageAction,
  updateOffer as updateOfferAction,
} from 'actions/inbox';

import SpinnerIcon from 'components/SpinnerIcon/SpinnerIcon';
import Form from 'components/Form/Form';

import styles from './job-send-offer.scss';

/**
 * This is the JobSendOffer component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class JobSendOffer extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    match: shape({
      params: shape({
        discussionId: string.isRequired,
      }).isRequired,
    }).isRequired,
    auth: shape({
      token: string.isRequired,
    }).isRequired,
    jobOfferForm: shape({
      fieldsets: array.isRequired,
      validationMessages: object.isRequired,
      submitText: string.isRequired,
      sending: bool.isRequired,
      errors: object.isRequired,
    }).isRequired,
    history: object.isRequired,
    message: object.isRequired,
    getMessage: func.isRequired,
    updateOffer: func.isRequired,
  };

  componentDidMount() {
    const {
      auth: { token },
      match: { params },
      message,
      getMessage,
    } = this.props;
    const loadMessage = message.discussion_id !== params.discussionId;

    if (loadMessage) {
      getMessage(token, params.discussionId);
    }
  }

  onSubmit = data => {
    const {
      auth: { token },
      message: { discussion_id },
      updateOffer,
      history,
    } = this.props;

    const {
      location: { state: locationState },
    } = history;

    // Default options, that gets merged with location state.
    const options = {
      callbackPath: null,
      ...locationState,
    };

    updateOffer(token, discussion_id, data).then(({ type, payload }) => {
      if (type === DISCUSSION_ACTION_SUCCESS) {
        const { callbackPath } = options;
        const path = callbackPath
          ? callbackPath
          : createUrl('message', payload.discussion_id);

        // Go to disussion page.
        history.push(path);
      }

      if (type === DISCUSSION_ACTION_FAILURE) {
        console.log('ERROR', payload); // @TODO: Handle error.
      }
    });
  };

  /**
   * Render JobSendOffer.
   *
   * @return {Object}
   */
  render() {
    const {
      message: { loading, talent_fullname, job_title },
      jobOfferForm,
    } = this.props;

    if (loading) {
      return (
        <div className={styles.spinner}>
          <SpinnerIcon medium />
        </div>
      );
    }

    return (
      <section className={styles.wrapper}>
        <div className={styles.row}>
          <header className={styles.header}>
            <h1>
              {p.t('jobs.offer.title', {
                name: talent_fullname,
                job: job_title,
              })}
            </h1>
          </header>

          <div className={styles.content}>
            <div className={styles.form}>
              <Form {...jobOfferForm} onSubmit={this.onSubmit} />
            </div>

            <div className={styles.disclaimer}>
              <p>{p.t('jobs.offer.disclaimer')}</p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

/**
 * Map state from redux store to props.
 */
const makeMapStateToProps = () => {
  const jobOfferForm = makeCreateJobOfferForm();

  const mapStateToProps = (state, props) => {
    return {
      auth: state.auth,
      message: state.message,
      jobOfferForm: jobOfferForm(state, props),
    };
  };
  return mapStateToProps;
};

export default withRouter(
  connect(
    makeMapStateToProps,
    {
      getMessage: getMessageAction,
      updateOffer: updateOfferAction,
    }
  )(JobSendOffer)
);
